import React, { useState, useEffect, useRef } from "react";
import GiftCardRateTable from "../../components/giftcardratesTable/GiftCardRateTable";
import ResultNotFound from "../resultNotFound/ResultNotFound";
import axios from "axios";
import "./giftcardrates.css";

const GiftCardRates = () => {
  const [cardsRate, setCardsRate] = useState([]);
  const [filteredRates, setFilteredRates] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const contentRef = useRef(null);
  const [currentDateTime, setCurrentDateTime] = useState("");

  // Fetch API data
  useEffect(() => {
    const params = new URLSearchParams();
    params.append("appid", "android-v1");
    params.append("sign", "8c5ce752342c23686d3f613208949305");
    params.append("country_id", "14");

    axios
      .post("https://api.giftcard8.com/gc/card/list", params, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        setCardsRate(res.data.data);
        setFilteredRates(res.data.data);
      })
      .catch((err) => console.error("API Request Failed:", err))
      .finally(() => setLoading(false));
  }, []);

  // Filter based on search query
  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredRates(cardsRate);
      return;
    }
    const filtered = cardsRate.filter((rate) =>
      rate.category_name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredRates(filtered);
  }, [searchQuery, cardsRate]);

  // Current date & time
  useEffect(() => {
    const now = new Date();
    const formatted = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(now.getDate()).padStart(2, "0")} / (${String(now.getHours()).padStart(
      2,
      "0"
    )}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(
      2,
      "0"
    )})`;
    setCurrentDateTime(formatted);
  }, []);

  const handleFocus = () => setIsSearchFocused(true);
  const handleBlur = () => setIsSearchFocused(false);
  const handleInput = () => {
    if (contentRef.current) setSearchQuery(contentRef.current.innerText);
  };

  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      {/* SEARCH BAR */}
      <div style={{ marginBottom: "30px" }}>
        <div
          ref={contentRef}
          contentEditable
          suppressContentEditableWarning
          onFocus={handleFocus}
          onBlur={handleBlur}
          onInput={handleInput}
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "6px",
            minHeight: "40px",
            fontSize: "16px",
            backgroundColor: "transparent",
            color: searchQuery ? "black" : "#6c757d",
          }}
        >
          {!isSearchFocused && !searchQuery && "Search giftcards"}
        </div>
      </div>

      {/* HEADER */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
        <h1>Gift Card Rates</h1>
        <div
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "6px",
          }}
        >
          Current Rates: <strong>{currentDateTime}</strong>
        </div>
      </div>

      {/* RATES TABLE */}
      {loading ? (
        <p>Loading...</p>
      ) : filteredRates.length > 0 ? (
        filteredRates.map((rate) => (
          <GiftCardRateTable
            key={rate.category_id}
            logo={rate.category_logo_img}
            cardName={rate.category_name}
            list={rate.list}
          />
        ))
      ) : (
        <ResultNotFound />
      )}
    </div>
  );
};

export default GiftCardRates;
